<template>
  <v-row class="app-form-fields ma-0">
    <v-col
      class="px-3 xs"
      cols="12"
      md="3"
      sm="3"
    >
      <autocomplete
        ref="refAccount"
        v-model="account"
        :title="(typeProp == 'pay' ? $t('reciever') : $t('payer'))"
        type="person"
        :new-btn="true"
        :value="account"
      />
    </v-col>
    <v-col
      v-show="typeProp == 'recieve'"
      class="px-3 xs pb-0"
      cols="12"
      md="2"
      sm="2"
    >
      <div class="cmp-header-remain">
        <span>{{ $t('composite-customer-remain') }}</span>
        <strong>{{ $numberFormat(parseFloat((personInfo && personInfo.remain ? personInfo.remain.remain : 0))) }} {{ (currency ? currency.name : '') }}</strong>
      </div>
    </v-col>
    <v-col
      cols="12"
      md="2"
      sm="3"
    >
      <template>
        <v-text-field
          id="headerDate"
          v-model="date"
          :label="$t('date')"
          :rules="[v => !!v || $t('is-required')]"
          clear-icon="flaticon2-close-cross"
          outlined
          dense
          clearable
        />
        <date-picker
          v-model="date"
          element="headerDate"
          :locale="$store.state.date_locale"
          :format="$store.state.date_format"
          auto-submit
          :min="$store.state.startDate"
          :max="$store.state.endDate"
          :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
          @close="setDate"
        />
      </template>
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <autocomplete
        ref="refCurrency"
        v-model="currency"
        :rules="[v => !!v || $t('is-required')]"
        :title="$t('currency')"
        type="currency"
        :set-init="true"
      />
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <money
        v-model="currencyAmount"
        :label="$t('currency-rate')"
        :dense="true"
        :outlined="true"
        :rules="[v => !!v || $t('is-required')]"
        :solo="false"
        :clearable="true"
        value-when-is-empty=""
        :options="options"
      />
    </v-col>
  </v-row>
</template>

<script>
  import General from '@/Mixins/general'
  export default {
    name: 'CompositeHeader',
    mixins: [General],
    props: ['typeProp'],
    data () {
      return {
        account: null, // To store the selected account
        date: null, // To store the selected date
        type: 'pay', // Default type can be either 'pay' or 'recieve'
        personInfo: {}, // To store information about the person
        currency: null, // To store currency information
        currencyAmount: 1, // To store currency information
      }
    },
    computed: {
      // Computed properties if any can be added here
    },

    watch: {
      $data: {
        handler (newVal, oldVal) {
          this.emitData()
        },
        deep: true,
      },
    },
    mounted () {
    },
    methods: {
      emitData () {
        this.$emit('input', {
          account: this.account,
          date: this.date,
          currency: this.currency,
          currencyAmount: this.currencyAmount,
        })
      },
    },
  }
</script>

<style scoped>

</style>
